// @flow
import BaseViewModel from './base';

export default class OsagoViewModel
	extends BaseViewModel
	implements IViewModel {
	constructor (options) {
		super(options);
		
		this._options = options;

		this.codeInputMask = '9999';

		this._subscriptions = [];

		this._init();
	}

	_init (): void {
		this._applyDataModelSubscribtions();
	}

	_applyDataModelSubscribtions = (): void => {
		this._subscribeToCode();
	}

	_subscribeToCode = (): void => {
		this._subscriptions.push(
			this.Code.subscribe(v => {
				this._options.descendingSettings.dataModel.Code(v);
			})
		);
	}
}